import { Injectable } from '@angular/core';
import { HttpService } from "../core/http/http.service";
import { IContact, IIdName } from '../_entities';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class ContactService extends DataAccessServiceBase<IContact> {
    contactTemplates: Promise<IIdName[]>;

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/contact";
    }

    getTemplates(): Promise<IIdName[] | any> {
        if (this.contactTemplates == null) {
            this.contactTemplates = this.httpService.get<IIdName[]>(`${this.getControllerUrl()}/templates`);

        }
        return this.contactTemplates
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

    getTemplatesForSupplier(supplierId: number): Promise<IIdName[] | any> {
        return this.httpService.get<IIdName[]>(`${this.getControllerUrl()}/templates/${supplierId}`)
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/contact.service.ts